import { Dropdown, useBreakpoint } from "@brg/ui";
import { LayoutConst } from "core";
import { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import { AppTester } from "supporting";
import { StyledDropdownListItem } from "../tooltips/ProjectTooltip";
import { ReactComponent as ShevronSvg } from "../FoldersDropdown/Arrows.svg";
import { NestedDropdownWrapper, NestedDropdownTarget } from "../nestedDropdown/styles";
import { ProjectCompetitionsPanel, useHasProjectCompetitions } from "shared/pages/project/components/ProjectCompetitionsPanel";

export const CompetitionsDropdown: FC<{
    project: any;
    isContinuumSite?: boolean;
    isProfile?: boolean;
    toggleTooltip?: (v: any) => void;
    portal?: boolean;
    closeOnMouseLeave?: boolean;
}> = ({
    project,
    isContinuumSite,
    isProfile,
    toggleTooltip,
    portal,
    closeOnMouseLeave,
}) => {
    const { t } = useTranslation();
    const isTouchLayout = useBreakpoint(LayoutConst.screen.s - 1);
    const isMobile = useBreakpoint(LayoutConst.screen.s - 1);
    const isGeo = AppTester.isGeograffee();
    const [isSubmenuOpen, setIsSubmenuOpen] = useState(false);
    const [mobileOpen, setMobileOpen] = useState(false);
    const hasCompetitions = useHasProjectCompetitions(project);

    const shouldRenderPanel = isSubmenuOpen || mobileOpen;

    if (!hasCompetitions) {
        return null;
    }

    return (
        <StyledDropdownListItem
            isContinuumSite={isContinuumSite}
            isProfile={isProfile}
            onMouseEnter={() => {
                if (!portal) setIsSubmenuOpen(true);
                if (!portal) toggleTooltip?.(true);
            }}
            onMouseLeave={() => {
                if (!portal) setIsSubmenuOpen(false);
                if (!portal) toggleTooltip?.(false);
            }}
            onClick={(ev) => {
                ev.preventDefault();
                ev.stopPropagation();
                if (isTouchLayout) setMobileOpen(!mobileOpen);
            }}
        >
            <NestedDropdownWrapper>
                <Dropdown
                    hoverOpen={closeOnMouseLeave !== false}
                    {...({
                        portal,
                        portalGap: isMobile ? 56 : undefined,
                        portalMaxWidth: isMobile ? 350 : 420,
                        closeOnMouseLeave,
                        onOpenChange: (isOpen: boolean) => {
                            if (!portal) return;
                            setIsSubmenuOpen(isOpen);
                            toggleTooltip?.(isOpen);
                        },
                    } as any)}
                    dark={isGeo}
                    offsetArrowY={0}
                    offsetX={-20}
                    offsetY={-140}
                    target={
                        <NestedDropdownTarget>
                            {t('nominate_to_competition').toLowerCase()}
                            <ShevronSvg />
                        </NestedDropdownTarget>
                    }
                >
                    {shouldRenderPanel && <ProjectCompetitionsPanel project={project} fullWidth />}
                </Dropdown>
            </NestedDropdownWrapper>
        </StyledDropdownListItem>
    );
};
import { Dropdown, useBreakpoint } from "@brg/ui";
import { LayoutConst } from "core";
import { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import { AppTester } from "supporting";
import { StyledDropdownListItem } from "../tooltips/ProjectTooltip";
import { ReactComponent as ShevronSvg } from "../FoldersDropdown/Arrows.svg";
import { NestedDropdownWrapper, NestedDropdownTarget } from "../nestedDropdown/styles";
import { ProjectCompetitionsPanel, useHasProjectCompetitions } from "shared/pages/project/components/ProjectCompetitionsPanel";

export const CompetitionsDropdown: FC<{
    project: any;
    isContinuumSite?: boolean;
    isProfile?: boolean;
    toggleTooltip?: (v: any) => void;
    portal?: boolean;
    closeOnMouseLeave?: boolean;
}> = ({
    project,
    isContinuumSite,
    isProfile,
    toggleTooltip,
    portal,
    closeOnMouseLeave,
}) => {
    const { t } = useTranslation();
    const isTouchLayout = useBreakpoint(LayoutConst.screen.s - 1);
    const isMobile = useBreakpoint(LayoutConst.screen.s - 1);
    const isGeo = AppTester.isGeograffee();
    const [isSubmenuOpen, setIsSubmenuOpen] = useState(false);
    const [mobileOpen, setMobileOpen] = useState(false);
    const hasCompetitions = useHasProjectCompetitions(project);

    const shouldRenderPanel = isSubmenuOpen || mobileOpen;

    if (!hasCompetitions) {
        return null;
    }

    return (
        <StyledDropdownListItem
            isContinuumSite={isContinuumSite}
            isProfile={isProfile}
            onMouseEnter={() => {
                if (!portal) setIsSubmenuOpen(true);
                if (!portal) toggleTooltip?.(true);
            }}
            onMouseLeave={() => {
                if (!portal) setIsSubmenuOpen(false);
                if (!portal) toggleTooltip?.(false);
            }}
            onClick={(ev) => {
                ev.preventDefault();
                ev.stopPropagation();
                if (isTouchLayout) setMobileOpen(!mobileOpen);
            }}
        >
            <NestedDropdownWrapper>
                <Dropdown
                    hoverOpen={closeOnMouseLeave !== false}
                    {...({
                        portal,
                        portalGap: isMobile ? 56 : undefined,
                        portalMaxWidth: isMobile ? 350 : 420,
                        closeOnMouseLeave,
                        onOpenChange: (isOpen: boolean) => {
                            if (!portal) return;
                            setIsSubmenuOpen(isOpen);
                            toggleTooltip?.(isOpen);
                        },
                    } as any)}
                    dark={isGeo}
                    offsetArrowY={0}
                    offsetX={-20}
                    offsetY={-140}
                    target={
                        <NestedDropdownTarget>
                            {t('nominate_to_competition').toLowerCase()}
                            <ShevronSvg />
                        </NestedDropdownTarget>
                    }
                >
                    {shouldRenderPanel && <ProjectCompetitionsPanel project={project} fullWidth />}
                </Dropdown>
            </NestedDropdownWrapper>
        </StyledDropdownListItem>
    );
};
